export const INITIALIZE_ACCOUNT_SETTINGS = 'initialize-account-settings';

const initializeAccountSettings = () => (
  { type: INITIALIZE_ACCOUNT_SETTINGS }
);

export default initializeAccountSettings;

